/**
 * @generated SignedSource<<54dafc7c52e9b3d8385007b0b024d35a>>
 * @relayHash 7e1598240d927482c8602146e677aa57
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7e1598240d927482c8602146e677aa57

import { ConcreteRequest } from 'relay-runtime';
export type AsynchronousQuestionnaireUsage = "ACCEPTED" | "ALL" | "DECLINED";
export type Country = "CH" | "DE";
export type Language = "ENGLISH" | "FRENCH" | "GERMAN" | "ITALIAN";
export type TreatmentPlanTemplateFilterInput = {
  amountOfDays?: IntOperationFilterInput | null;
  and?: ReadonlyArray<TreatmentPlanTemplateFilterInput> | null;
  asynchronousQuestionnaireUsage?: NullableOfAsynchronousQuestionnaireUsageOperationFilterInput | null;
  countries?: ListCountryOperationFilterInput | null;
  createdAt?: DateTimeOperationFilterInput | null;
  createdBy?: StringOperationFilterInput | null;
  id?: IdOperationFilterInput | null;
  isDraft?: BooleanOperationFilterInput | null;
  isGlobal?: BooleanOperationFilterInput | null;
  languages?: ListFilterInputTypeOfTreatmentPlanTemplateLanguageFilterInput | null;
  name?: StringOperationFilterInput | null;
  or?: ReadonlyArray<TreatmentPlanTemplateFilterInput> | null;
  treatmentPlanTemplateIcdCodes?: ListFilterInputTypeOfTreatmentPlanTemplateIcdCodeFilterInput | null;
  updatedAt?: DateTimeOperationFilterInput | null;
  updatedBy?: StringOperationFilterInput | null;
};
export type IntOperationFilterInput = {
  eq?: number | null;
  gt?: number | null;
  gte?: number | null;
  in?: ReadonlyArray<number | null> | null;
  lt?: number | null;
  lte?: number | null;
  neq?: number | null;
  ngt?: number | null;
  ngte?: number | null;
  nin?: ReadonlyArray<number | null> | null;
  nlt?: number | null;
  nlte?: number | null;
};
export type NullableOfAsynchronousQuestionnaireUsageOperationFilterInput = {
  eq?: AsynchronousQuestionnaireUsage | null;
  in?: ReadonlyArray<AsynchronousQuestionnaireUsage | null> | null;
  neq?: AsynchronousQuestionnaireUsage | null;
  nin?: ReadonlyArray<AsynchronousQuestionnaireUsage | null> | null;
};
export type ListCountryOperationFilterInput = {
  all?: CountryOperationFilterInput | null;
  any?: boolean | null;
  none?: CountryOperationFilterInput | null;
  some?: CountryOperationFilterInput | null;
};
export type CountryOperationFilterInput = {
  eq?: Country | null;
  in?: ReadonlyArray<Country> | null;
  neq?: Country | null;
  nin?: ReadonlyArray<Country> | null;
};
export type DateTimeOperationFilterInput = {
  eq?: string | null;
  gt?: string | null;
  gte?: string | null;
  in?: ReadonlyArray<string | null> | null;
  lt?: string | null;
  lte?: string | null;
  neq?: string | null;
  ngt?: string | null;
  ngte?: string | null;
  nin?: ReadonlyArray<string | null> | null;
  nlt?: string | null;
  nlte?: string | null;
};
export type StringOperationFilterInput = {
  and?: ReadonlyArray<StringOperationFilterInput> | null;
  contains?: string | null;
  endsWith?: string | null;
  eq?: string | null;
  in?: ReadonlyArray<string | null> | null;
  ncontains?: string | null;
  nendsWith?: string | null;
  neq?: string | null;
  nin?: ReadonlyArray<string | null> | null;
  nstartsWith?: string | null;
  or?: ReadonlyArray<StringOperationFilterInput> | null;
  startsWith?: string | null;
};
export type IdOperationFilterInput = {
  eq?: string | null;
  in?: ReadonlyArray<string | null> | null;
  neq?: string | null;
  nin?: ReadonlyArray<string | null> | null;
};
export type BooleanOperationFilterInput = {
  eq?: boolean | null;
  neq?: boolean | null;
};
export type ListFilterInputTypeOfTreatmentPlanTemplateLanguageFilterInput = {
  all?: TreatmentPlanTemplateLanguageFilterInput | null;
  any?: boolean | null;
  none?: TreatmentPlanTemplateLanguageFilterInput | null;
  some?: TreatmentPlanTemplateLanguageFilterInput | null;
};
export type TreatmentPlanTemplateLanguageFilterInput = {
  and?: ReadonlyArray<TreatmentPlanTemplateLanguageFilterInput> | null;
  followUpInstructions?: StringOperationFilterInput | null;
  language?: LanguageOperationFilterInput | null;
  or?: ReadonlyArray<TreatmentPlanTemplateLanguageFilterInput> | null;
  recommendedTreatment?: StringOperationFilterInput | null;
  synonym?: StringOperationFilterInput | null;
  title?: StringOperationFilterInput | null;
};
export type LanguageOperationFilterInput = {
  eq?: Language | null;
  in?: ReadonlyArray<Language> | null;
  neq?: Language | null;
  nin?: ReadonlyArray<Language> | null;
};
export type ListFilterInputTypeOfTreatmentPlanTemplateIcdCodeFilterInput = {
  all?: TreatmentPlanTemplateIcdCodeFilterInput | null;
  any?: boolean | null;
  none?: TreatmentPlanTemplateIcdCodeFilterInput | null;
  some?: TreatmentPlanTemplateIcdCodeFilterInput | null;
};
export type TreatmentPlanTemplateIcdCodeFilterInput = {
  and?: ReadonlyArray<TreatmentPlanTemplateIcdCodeFilterInput> | null;
  diagnosisCode?: StringOperationFilterInput | null;
  id?: IdOperationFilterInput | null;
  or?: ReadonlyArray<TreatmentPlanTemplateIcdCodeFilterInput> | null;
  treatmentPlanTemplate?: TreatmentPlanTemplateFilterInput | null;
  treatmentPlanTemplateId?: IntOperationFilterInput | null;
};
export type treatmentPlanTemplateSelectorQuery$variables = {
  filters?: TreatmentPlanTemplateFilterInput | null;
};
export type treatmentPlanTemplateSelectorQuery$data = {
  readonly treatmentPlanTemplates: ReadonlyArray<{
    readonly countries: ReadonlyArray<Country>;
    readonly icdDiagnoses: ReadonlyArray<{
      readonly diagnosisCode: string;
      readonly id: string;
      readonly text: string;
    }>;
    readonly id: string;
    readonly languages: ReadonlyArray<{
      readonly followUpInstructions: string | null;
      readonly language: Language;
      readonly recommendedTreatment: string | null;
      readonly synonym: string | null;
      readonly title: string;
    }>;
    readonly name: string;
  }>;
};
export type treatmentPlanTemplateSelectorQuery = {
  response: treatmentPlanTemplateSelectorQuery$data;
  variables: treatmentPlanTemplateSelectorQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filters"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "where",
        "variableName": "filters"
      }
    ],
    "concreteType": "TreatmentPlanTemplate",
    "kind": "LinkedField",
    "name": "treatmentPlanTemplates",
    "plural": true,
    "selections": [
      (v1/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "countries",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "TreatmentPlanTemplateLanguage",
        "kind": "LinkedField",
        "name": "languages",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "language",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "synonym",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "followUpInstructions",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "recommendedTreatment",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "IcdDiagnosis",
        "kind": "LinkedField",
        "name": "icdDiagnoses",
        "plural": true,
        "selections": [
          (v1/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "diagnosisCode",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "text",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "treatmentPlanTemplateSelectorQuery",
    "selections": (v2/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "treatmentPlanTemplateSelectorQuery",
    "selections": (v2/*:: as any*/)
  },
  "params": {
    "id": "7e1598240d927482c8602146e677aa57",
    "metadata": {},
    "name": "treatmentPlanTemplateSelectorQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "f1e38c7037ded479620bdd1be3cdef27";

export default node;
